import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

function Modal({
  children,
  showModal,
  setShowModal,
  showCloseButton,
  clickOut,
  closeOnEscape,
  noPadding = false,
  maxWidth,
}) {
  const modalRef = useRef(null); // Manage focus on the modal when it is opened.

  const handleKeyPressAndClickOut = (event) => {
    if (
      (event.key === "Escape" && closeOnEscape) ||
      (event.target.id === "modalExample" && event.type === "mousedown")
    ) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (showModal && modalRef.current) {
      document.addEventListener("keydown", handleKeyPressAndClickOut);
      if (clickOut) {
        document.addEventListener("mousedown", handleKeyPressAndClickOut);
      }
      modalRef.current.focus();
    }

    return () => {
      document.removeEventListener("keydown", handleKeyPressAndClickOut);
      if (clickOut) {
        document.removeEventListener("mousedown", handleKeyPressAndClickOut);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, clickOut, closeOnEscape]);

  // Lock page scroll while the modal is open.
  useEffect(() => {
    if (!showModal) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [showModal]);

  if (!showModal) return null;

  // Render into body so the modal always sits above the nav header.
  return createPortal(
    <>
      <div
        className="modal fade show d-block"
        id="modalExample"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalExampleTitle"
        aria-modal="true"
        onKeyDown={handleKeyPressAndClickOut}
        ref={modalRef}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          role="document"
          style={maxWidth ? { maxWidth } : undefined}
        >
          <div className="modal-content">
            {showCloseButton && (
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              ></button>
            )}

            {/* noPadding: children provide their own header/body, kept as direct children so the header stays fixed */}
            {noPadding ? (
              children
            ) : (
              <div className="modal-body p-5">{children}</div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>,
    document.body,
  );
}

export default Modal;
